export const orderDetails = {
  returnBackButton: 'Back to Orders',
  upcomingOrderDetails: {
    pageTitle: 'Subscription Order',
    orderDefaultStatus: 'Unpaid',
    orderInformation: {
      orderDateLabel: 'Order Date',
      subscriptionNameLabel: 'Subscription',
      statusLabel: 'Status',
      totalLabel: 'Total'
    },
    shipNowButton: 'Ship Now',
    skipShipmentButton: 'Skip Shipment',
    changeDateButton: 'Order Date',
    subscriptionProductsList: 'Subscription Products:',
    manageSubscriptionButton: 'Manage Subscription',
    emptyOrders: {
      title: 'One Time Add-Ons',
      description:
        'Shop the full range of AG1 products and accessories, available exclusively to members.',
      buttonName: 'Add Product to Order'
    },
    oneTimeField: {
      oneTimeProductsList: 'One Time Add-Ons',
      addProducrToOrderButton: 'Add Product to Order',
      oneTimeSubtottal: 'One Time Add-Ons Subtotal'
    }
  },
  pastOrdersDetails: {
    pageTitle: 'Order',
    freeGiftTitle: 'Share Free Packs',
    orderItems: 'Order Items',
    trackOrderButton: 'Track Order',
    subscriptionNameOTP: 'One-time purchase',
    defaultOrderStatus: 'Not Available',
    orderInformation: {
      orderDateLabel: 'Order Date',
      subscriptionNameLabel: 'Subscription',
      statusLabel: 'Status',
      totalLabel: 'Total'
    }
  },
  missingValue: 'Not Available'
};
